import { InjectionToken } from '@angular/core';

// todo: add type
export const ENVIRONMENT = new InjectionToken<any>('environment_avo3');
